import React from 'react';
import SystemSettingsView from './SystemSettingsView';
import SystemSettingsLogic from './SystemSettingsLogic';
import { PageTitle } from './';

export default function SystemSettings() {
  const {
    allowedFileTypes,
    users,
    loading,
    usersLoading,
    error,
    newFileType,
    generalSettings,
    selectedUser,
    selectedUserApplications,
    applicationsLoading,
    handleGeneralSettingsUpdate,
    handleInputChange,
    handleAddFileType,
    handleToggleFileType,
    handleDeleteFileType,
    handleUpdateFileType,
    handleUserSelect,
    handleModalClose,
    saveSuccess
  } = SystemSettingsLogic();

  return (
    <>
      <PageTitle title="System Settings" />
      <SystemSettingsView
        allowedFileTypes={allowedFileTypes}
        users={users}
        loading={loading}
        usersLoading={usersLoading}
        error={error}
        newFileType={newFileType}
        generalSettings={generalSettings}
        selectedUser={selectedUser}
        selectedUserApplications={selectedUserApplications}
        applicationsLoading={applicationsLoading}
        handleGeneralSettingsUpdate={handleGeneralSettingsUpdate}
        onInputChange={handleInputChange}
        onAddFileType={handleAddFileType}
        onToggleFileType={handleToggleFileType}
        onDeleteFileType={handleDeleteFileType}
        onUpdateFileType={handleUpdateFileType}
        onUserSelect={handleUserSelect}
        onModalClose={handleModalClose}
        saveSuccess={saveSuccess}
      />
    </>
  );
} 